import React, { useState } from 'react';
import { toast } from 'sonner';
import { X, Download, Share2, ExternalLink, FileText, Loader2 } from 'lucide-react';

const PDF_URL = `${process.env.REACT_APP_BACKEND_URL}/api/descritivo-tecnico/pdf`;
const PDF_NAME = 'Descritivo_Tecnico_Gestao_de_Maquinas.pdf';

export const DescritivoTecnicoModal = ({ open, onClose }) => {
  const [loading, setLoading] = useState(null);

  if (!open) return null;

  const fetchBlob = async () => {
    const r = await fetch(PDF_URL);
    if (!r.ok) throw new Error('Falha ao gerar o PDF');
    return r.blob();
  };

  const baixar = async () => {
    setLoading('baixar');
    try {
      const blob = await fetchBlob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = PDF_NAME;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Descritivo Técnico baixado');
    } catch (_e) {
      toast.error('Erro ao baixar o Descritivo Técnico');
    } finally {
      setLoading(null);
    }
  };

  const compartilhar = async () => {
    setLoading('compartilhar');
    try {
      const blob = await fetchBlob();
      const file = new File([blob], PDF_NAME, { type: 'application/pdf' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: 'Descritivo Técnico do Sistema' });
      } else {
        toast.info('Compartilhamento não suportado neste dispositivo. Baixando o PDF...');
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = PDF_NAME;
        document.body.appendChild(a); a.click(); a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (e) {
      if (e && e.name !== 'AbortError') toast.error('Erro ao compartilhar o Descritivo Técnico');
    } finally {
      setLoading(null);
    }
  };

  const abrirNovaAba = () => {
    window.open(PDF_URL, '_blank', 'noopener,noreferrer');
  };

  const Btn = ({ id, icon: Icon, label, onClick, primary }) => (
    <button
      onClick={onClick}
      disabled={!!loading}
      data-testid={`descritivo-${id}-btn`}
      className={`w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg font-medium transition-colors disabled:opacity-50 ${
        primary
          ? 'bg-yellow-500 text-black hover:bg-yellow-400'
          : 'bg-gray-800 text-gray-200 hover:bg-gray-700 border border-gray-700'
      }`}
    >
      {loading === id ? <Loader2 size={18} className="animate-spin" /> : <Icon size={18} />}
      <span>{label}</span>
    </button>
  );

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="descritivo-tecnico-modal">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-[#1A1A1A] border border-gray-700 rounded-xl shadow-2xl p-6">
        <button
          onClick={onClose}
          data-testid="descritivo-fechar-x-btn"
          className="absolute top-3 right-3 p-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-colors"
        >
          <X size={18} />
        </button>
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2.5 rounded-lg bg-yellow-500/10 text-yellow-500">
            <FileText size={22} />
          </div>
          <h2 className="text-lg font-semibold text-white">Descritivo Técnico</h2>
        </div>
        <p className="text-sm text-gray-400 mb-5">
          Manual técnico do sistema em PDF, sempre com a versão e data/hora da última atualização.
        </p>
        <div className="space-y-2.5">
          <Btn id="baixar" icon={Download} label="Baixar PDF" onClick={baixar} primary />
          <Btn id="compartilhar" icon={Share2} label="Compartilhar" onClick={compartilhar} />
          <Btn id="nova-aba" icon={ExternalLink} label="Abrir em nova aba" onClick={abrirNovaAba} />
          <button
            onClick={onClose}
            data-testid="descritivo-fechar-btn"
            className="w-full px-4 py-2.5 rounded-lg text-gray-400 hover:text-white transition-colors text-sm"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};
